import { Avatar } from 'antd';
import React from 'react';

function getFirstAndLastLetters(name) {
    // const words = name.split(/\s+/);
    // let initials = '';
    // if (words.length > 0) {
    //     initials += words[0].charAt(0).toUpperCase();
    //     if (words.length > 1) {
    //         initials += words[words.length - 1].charAt(0).toUpperCase();
    //     }
    // }
    // return initials;

    // this function read hindi kannada and english and give an output of first letter       

    const words = name?.trim()?.split(/\s+/); 
    let initials = '';
    if (words?.length > 0) {
        initials += words[0]?.charAt(0);
        if (words?.length > 1) {
            initials += words[words?.length - 1]?.charAt(0);
        }
    }
    return initials?.toUpperCase();
}

const colors = [
    {
        bg: "#C9E8F2",
        text: "#32869F"
    },
    {
        bg: "#EFE1E4",
        text: "#B44950"
    },
    {
        bg: "#F1E6CB",
        text: "#99790A"
    },
    {
        bg: "#D3E9E6",
        text: "#008A67"
    },
    {
        bg: "#DFDEF5",
        text: "#594099"
    },
    {
        bg: "#E1EBCC",
        text: "#5E840E"
    }
];

const UserAvatar = React.memo((props) => {
    const { name, img, size, shape , fromProfileMenu, userEditProfile, fontSize} = props;
    const colorIndex = name ? name?.length % colors?.length : 0;
    const backgroundColor = props.backgroundColor ? (props.backgroundColor.startsWith('#') ? props.backgroundColor : `#${props.backgroundColor}`) : colors[colorIndex]?.bg;
    const textColor = props.textColor ? (props.textColor.startsWith('#') ? props.textColor : `#${props.textColor}`) : colors[colorIndex]?.text;


    return (
        <div>
            {img ? 
            (userEditProfile ? (
                <Avatar size={size} shape={shape} style={{ height: "auto", aspectRatio: "4/5", width: '100%', borderRadius: "17px" }} src={img} />)
                : 
                fromProfileMenu ? (
                <Avatar size={size} shape={shape} style={{ borderRadius: size * 2, height:'80px', width:'80px' }} src={img} />)
                :
                (<Avatar size={size} shape={shape} style={{ borderRadius: size * 2 }} src={img} />)
            ) : (
                userEditProfile ? (
                <Avatar size={size} shape={shape} style={{ height: "auto", aspectRatio: "4/5", width: '100%', display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "17px", fontSize:'40px', textTransform: 'uppercase', background: backgroundColor, color: textColor, fontWeight:props?.fontWeight ? 500 :"bold", fontFamily:"roboto" }}>
                    {getFirstAndLastLetters(name)}
                </Avatar>)
                :
                fromProfileMenu ?
                <Avatar size={size} shape={shape} style={{height:'80px', width:'80px', fontSize:'35px', paddingTop:23, textTransform: 'uppercase', background: backgroundColor, color: textColor, fontWeight:props?.fontWeight ? 500 :"bold", fontFamily:"roboto"}}>
                    {getFirstAndLastLetters(name)}
                </Avatar>
                :
                <Avatar size={size} shape={shape} style={{ textTransform: 'uppercase', background: backgroundColor, color: textColor, fontWeight:props?.fontWeight ? 500 :"bold", fontFamily:"roboto", ...(fontSize ? { fontSize } : {})}}>
                    {getFirstAndLastLetters(name)}
                </Avatar>
            )}
        </div>
    );
});

export default UserAvatar;